import axios from 'axios'

const axiosInstance = axios.create({ baseURL: window.appConfig.apiUrl })

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject(error.response)
)

export default axiosInstance
